import { render, staticRenderFns } from "./shopInfo.vue?vue&type=template&id=5df6a002&scoped=true"
import script from "./shopInfo.vue?vue&type=script&lang=js"
export * from "./shopInfo.vue?vue&type=script&lang=js"
import style0 from "./shopInfo.vue?vue&type=style&index=0&id=5df6a002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6a002",
  null
  
)

export default component.exports